import ReviewDecideService, { ReviewDecideServiceType } from "./ReviewDecideService";
import useStyles from "./ReviewDecideStyle";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function ReviewDecide() {
  const classes = useStyles();

  // eslint-disable-next-line
  const {}: ReviewDecideServiceType = ReviewDecideService();

  return (
    <Backdrop className={classes.backdrop} open={true} onClick={() => {}}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
